// extracted by mini-css-extract-plugin
export default {"icon":"ActivityTab_icon__dfMx5","icon-24":"ActivityTab_icon-24__Mkxnj"};